var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    shadows = _ref.shadows,
    colors = _ref.colors,
    breakpoints = _ref.breakpoints,
    transitions = _ref.transitions;
  return {
    contentTransitionDuration: transitions.duration,
    contentBackgroundColor: colors.white,
    contentMaxWidth: '79.5rem',
    contentMargin: spacing.medium,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    phoneContentMargin: spacing.xSmall,
    contentBoxShadow: shadows.depth1,
    contentBorderColor: colors.tiara,
    contentBorderRadius: '4px'
  };
};
export default generateComponentTheme;